import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "past-flat-list"
};
const _hoisted_2 = {
  class: "past-header"
};
const _hoisted_3 = {
  class: "btn-add"
};
const _hoisted_4 = {
  class: "past-items"
};
const _hoisted_5 = {
  class: "item-header"
};
const _hoisted_6 = {
  class: "item-title"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = {
  class: "form-row"
};
const _hoisted_9 = {
  class: "form-item"
};
const _hoisted_10 = {
  class: "input-wrapper"
};
const _hoisted_11 = {
  class: "form-item"
};
const _hoisted_12 = {
  class: "input-wrapper"
};
const _hoisted_13 = {
  class: "form-item"
};
const _hoisted_14 = {
  class: "input-wrapper"
};
const _hoisted_15 = {
  class: "form-row",
  style: {
    "margin-top": "15px"
  }
};
const _hoisted_16 = {
  class: "form-item"
};
const _hoisted_17 = {
  class: "input-wrapper"
};
const _hoisted_18 = {
  class: "form-item"
};
const _hoisted_19 = {
  class: "input-wrapper"
};
import { getDictListById } from "@/service/modules/dict";
import { ref, watch } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'past-flat-list',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:value", "add", "delete"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const pastList = ref([]);
    const treatmentResultList = ref([]);
    const commonDiseasesList = ref([]);
    getTypeList();
    async function getTypeList() {
      try {
        let {
          data
        } = await getDictListById(5);
        treatmentResultList.value = data.map(item => item.name);
      } catch {}
      try {
        let {
          data
        } = await getDictListById(6);
        commonDiseasesList.value = data.map(item => item.name);
      } catch {}
    }
    // 修改初始化数据的逻辑
    let isInternalUpdate = false;
    // 初始化数据
    watch(() => props.value, newVal => {
      if (isInternalUpdate) return;
      if (newVal && newVal.length > 0) {
        pastList.value = JSON.parse(JSON.stringify(newVal));
      } else {
        pastList.value = [];
      }
    }, {
      immediate: true,
      deep: true
    });
    // 更新数据
    watch(() => pastList.value, newVal => {
      if (newVal) {
        isInternalUpdate = true;
        emit("update:value", JSON.parse(JSON.stringify(newVal)));
        setTimeout(() => {
          isInternalUpdate = false;
        }, 0);
      }
    }, {
      deep: true
    });
    // 添加病史
    const handleAdd = () => {
      pastList.value.push({
        name: "",
        diagnosisTime: null,
        hospital: "",
        treatmentResult: "",
        remarks: ""
      });
      emit("add");
    };
    // 删除病史
    const handleDelete = index => {
      pastList.value.splice(index, 1);
      emit("delete", index);
    };
    // 处理日期变化
    const handleDateChange = (val, index) => {
      if (val) {
        pastList.value[index].diagnosisTime = new Date(val).getTime();
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        plain: "",
        class: "add-button",
        onClick: handleAdd
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 添加 ")])),
        _: 1
      })])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pastList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "past-item"
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, "病史" + _toDisplayString(index + 1), 1), _createVNode(_component_el_button, {
          type: "danger",
          size: "small",
          onClick: $event => handleDelete(index)
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("删除")])),
          _: 2
        }, 1032, ["onClick"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "label"
        }, "基本名称：", -1)), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_select, {
          modelValue: item.name,
          "onUpdate:modelValue": $event => item.name = $event,
          placeholder: "请选择",
          style: {
            "width": "100%"
          },
          filterable: "",
          clearable: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commonDiseasesList.value, disease => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: disease,
              label: disease,
              value: disease
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])]), _createElementVNode("div", _hoisted_11, [_cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "label"
        }, "诊断时间：", -1)), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_date_picker, {
          style: {
            "width": "100%"
          },
          modelValue: item.diagnosisTime,
          "onUpdate:modelValue": $event => item.diagnosisTime = $event,
          type: "date",
          placeholder: "请选择诊断时间",
          onChange: val => handleDateChange(val, index)
        }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])])]), _createElementVNode("div", _hoisted_13, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "label"
        }, "确诊医院：", -1)), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_input, {
          modelValue: item.hospital,
          "onUpdate:modelValue": $event => item.hospital = $event,
          placeholder: "请输入确诊医院"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "label"
        }, "治疗结果：", -1)), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_select, {
          modelValue: item.treatmentResult,
          "onUpdate:modelValue": $event => item.treatmentResult = $event,
          placeholder: "请选择治疗结果",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treatmentResultList.value, item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item,
              label: item,
              value: item
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"])])]), _createElementVNode("div", _hoisted_18, [_cache[6] || (_cache[6] = _createElementVNode("span", {
          class: "label"
        }, "备注：", -1)), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_input, {
          modelValue: item.remarks,
          "onUpdate:modelValue": $event => item.remarks = $event,
          placeholder: "请输入备注信息"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "form-item"
        }, null, -1))])])]);
      }), 128))])]);
    };
  }
});